<template>
  <div class="content-wrapper">
    <div class="card card-with-shadow border-0 bg-transparent">
      <div
          class="card-header d-flex align-items-center p-primary primary-card-color"
      >
        <h5 class="card-title d-inline-block mb-0">{{ pageTitle }}</h5>
        <app-search @input="getSearchValue" />
      </div>

      <div
          class="p-primary d-flex align-items-center primary-card-color border-bottom"
      >
        <ul class="nav tab-filter-menu justify-content-flex-end">
          <li
              class="nav-item"
              v-for="(item, index) in candidateFilterOptions"
              :key="index"
          >
            <a
                href="#"
                class="nav-link font-size-default py-0"
                :class="[
                filteredData.status == item.id
                  ? 'active'
                  : index === 0 && filteredData.status === ''
                  ? 'active'
                  : '',
              ]"
                @click.prevent="getFilterValue(item.id)"
            >
              {{ item.value }}
            </a>
          </li>
        </ul>
      </div>

      <div class="card-body p-0">
        <app-table
            :id="tableId"
            :options="options"
            :filtered-data="filteredData"
            :search="search"
            @action="getListAction"
        />
      </div>
    </div>
  </div>
</template>


<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {CANDIDATES, DELETE_APPLICATION} from '../../../../Config/ScreeningAppUrl';
import {Candidate} from "@Views/Screening/utility/apiAgent";
import DefaultFilter from "@Views/Demo/Tables/filter-type-datatable/default-filter";
import TabFilter from "@Views/Auth/JobTemplateList";
import * as actions from "@/app/Config/ApiUrl";

export default {
  components: {TabFilter, DefaultFilter},
  extends: CoreLibrary,
  name: "CandidateList",
  mixins: [TableHelpers],
  props: {
    active: Number,
    customerCompany: {},
  },

  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      selectedUrl: "",
      tableId: "candidates-listing-table",
      rowData: {},
      filteredData: {
        status: "",
      },
      search: "",
      candidateFilterOptions: [
        { id: "", value: "All" },
        { id: "complete", value: "Completed Applications" },
        { id: "inComplete", value: "Incomplete Applications"},

      ],
      options: {
        name: "AdvanceTable",
        url: CANDIDATES,
        datatableWrapper: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("Applicant Id"),
            type: "custom-html",
            key: "id",
            sortable: true,
            modifier: (value, row) => {
              const baseId = 10000;
              const applicantId = baseId + value;

              // Optional: Add company prefix or logic
              // e.g., if company_id = 3, you could show A03-10002
              const companyPrefix = row.company_id ? `C${String(row.company_id).padStart(2, '0')}-` : '';

              return `<span>${companyPrefix}${applicantId}</span>`;
            },
          },
          {
            title: this.$t("Employee Id"),
            type: "custom-html",
            key: "user_id",
            sortable: true,
            modifier: (value, row) => {
              return `<span>${value ?? '-'}</span>`;
            },
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "full_name",
            sortable: true,
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },

          {
            title: this.$t("email"),
            type: "custom-html",
            key: "email",
            sortable: true,
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("created_at"),
            type: "custom-html",
            key: "created_at",
            sortable: true,
            modifier: (value) => {
              var date = moment(value).format("DD-MM-YYYY");
              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Added To Screening"),
            type: "custom-html",
            key: "application_archive",
            modifier: (value, rowData, rowIndex, row) => {
              let date = value?.created_at??''
              if (date) date = moment(date).format("DD-MM-YYYY");

              return `<span>${this.$t(date)}</span>`;
            },
          },
          {
            title: this.$t("Status"),
            type: "custom-html",
            key: "application_archive",
            modifier: (value, rowData) => {
              let status = value?.archived_when??''
              return `<span>${this.$t(status)}</span>`;
            },
          },

          {
            title: this.$t("Forms Completion"),
            type: "custom-html",
            key: "form_completion_percentage",
            modifier: value =>
                `<span data-toggle="tooltip" title="This has been estimated by the completion of forms.">
                   ${value ? `${value}%` : ""}
                 </span>`
          },
          {
            title: this.$t("Screening Progress"),
            type: "custom-html",
            key: "completion_percentage",
            modifier: (value) => {
              return `<span data-toggle="tooltip" title="This represents the checks the applicant has passed.">
                ${value ? `${value}%` : ""}
                </span>`;
            },
          }
        ],
        actions: [
          {
            title: this.$t("view_current_application"),
            icon: "book",
            color: "#4A90E2", // Blue
          },
          {
            title: this.$t("view_original_application"),
            icon: "bookmark",
            color: "#F5A623", // Orange
          },
          {
            title: this.$t("download_application_form"),
            icon: "file",
            color: "#7ED321", // Green
          },
          {
            title: this.$t("Audit Trail"),
            icon: "file-text",
            color: "#9013FE", // Purple
          },
          {
            title: this.$t("shortlist"),
            icon: "file-plus",
            color: "#FFD700", // Gold
          },
          {
            title: this.$t("delete"),
            icon: "delete",
            color: "#D0021B", // Red
          },
        ],
        filters: [],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 30,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  mounted() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  methods: {
    getSearchValue(value) {
      this.search = value;
      setTimeout(() => {
        this.$hub.$emit("reload-" + this.tableId);
      });
    },
    getFilterValue(id) {
      this.filteredData.status = id;
      this.$hub.$emit("reload-" + this.tableId);
    },
    getPageTitle() {
      let pageTitle = 'Candidates For Screening';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("shortlist")) {
        this.shortlistCandidate(rowData.id);
      } else if (actionObj.title == this.$t("download_application_form")) {
        // If application is added to screening, open the report in a new tab;
        // otherwise show a clear error message to the user.
        if (rowData.application_archive && rowData.application_archive.id) {
          window.open('/generate-candidate-screening-report/applicationForm?applicant_id='+rowData.id, '_blank');
        } else {
          this.$toastr.e('Please first add this application to screening.');
        }
      } else if (actionObj.title == this.$t("Audit Trail")) {
        if (rowData.application_archive && rowData.application_archive.id) {
          window.open('/generate-candidate-screening-report/auditTrail?applicant_id='+rowData.id, '_blank');
        } else {
          this.$toastr.e('Please first add this application to screening.');
        }
      } else if (actionObj.title == this.$t("view_current_application")) {
        window.open(`/candidate-detail/${rowData.company_id}/${rowData.id}`, '_blank');
      } else if (actionObj.title == this.$t("view_original_application")) {
        window.open(`/candidate-detail/${rowData.company_id}/${rowData.id}?applicant_archive=${rowData.application_archive?.id}`, '_blank');
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteApplication(rowData.company_id, rowData.id)
      }

    },
    deleteApplication(companyId, applicantId){
      if (confirm('Are you sure to delete this application?')){
        let deleteUrl =`${DELETE_APPLICATION}/${companyId}/${applicantId}`;
        this.axiosDelete(deleteUrl)
            .then((response) => {
              const msg = (response && response.data) ? response.data : 'Deleted successfully';
              this.$toastr.s(msg);
            })
            .catch((error) => {
              const msg = error?.response?.data?.message || error?.response?.data || error?.message || 'Error deleting application';
              this.$toastr.e(msg);
            })
            .finally(() => {
              this.$hub.$emit("reload-" + this.tableId);
            });
      }

    },
    shortlistCandidate(applicantId) {
      Candidate.shortListCandidate(applicantId)
          .then((response) => {
            const msg = response?.data?.message || response?.data || 'Shortlisted';
            this.$toastr.s(msg);
          })
          .catch((error) => {
            const msg = error?.response?.data?.message || error?.response?.data || error?.message || 'An error occurred';
            this.$toastr.e(msg);
          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },

    downloadApplicationForm(applicantId) {
      const url = `/generate-candidate-screening-report/applicationForm?applicant_id=${applicantId}`;
      // Request as blob so we can handle file download or JSON error message
      this.axiosGet(url, { responseType: 'blob' })
          .then((response) => {
            const headers = response.headers || {};
            const contentType = (headers['content-type'] || headers['Content-Type'] || '') + '';

            // If server returned JSON (error) inside a blob, parse and show message
            if (contentType.indexOf('application/json') !== -1) {
              return response.data.text().then((text) => {
                let json = {};
                try { json = JSON.parse(text); } catch (e) {}
                const msg = json.message || text || 'An error occurred';
                this.$toastr.e(msg);
              });
            }

            // Otherwise treat as file blob and trigger download
            const blob = new Blob([response.data], { type: contentType });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            // Attempt to get filename from headers
            const disposition = headers['content-disposition'] || headers['Content-Disposition'] || '';
            let filename = `application_${applicantId}.pdf`;
            const fileNameMatch = /filename="?([^";]+)"?/.exec(disposition);
            if (fileNameMatch && fileNameMatch[1]) filename = fileNameMatch[1];
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
          })
          .catch((error) => {
            const msg = error?.response?.data?.message || error?.response?.data || error?.message || 'Error downloading application';
            this.$toastr.e(msg);
          });
    }
  }
};
</script>